import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const categoryIcons: Record<string, string> = {
  guoman: 'ri-flag-2-line',
  rexue: 'ri-fire-line',
  lianai: 'ri-heart-line',
  xuanhuan: 'ri-magic-line',
  wuxia: 'ri-sword-line',
  kehuan: 'ri-rocket-line',
  xuanyi: 'ri-search-eye-line',
  gaoxiao: 'ri-emotion-laugh-line',
  qihuan: 'ri-moon-line',
  dushi: 'ri-building-line',
};

export default function CategorySection() {
  return (
    <section className="w-full bg-background-100/70" aria-label="漫画分类">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
            漫画分类
          </h2>
          <p className="text-foreground-500 text-sm">探索你喜欢的漫画类型，发现更多精彩作品</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
          {categories.filter(c => c.slug !== 'all').map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-background-50 hover:bg-primary-50 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${categoryIcons[cat.slug] || 'ri-bookmark-line'} text-xl md:text-2xl text-primary-500`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}